import { lazy, useState } from "react";
import { Fade } from "@mui/material";
import PropTypes from "prop-types";

import LazyLoader from "src/components/layout/Progress/LazyLoader";
import MyDivider2 from "src/components/layout/MyDivider2";
import Attachments_list from "src/pages/attachments/components/Attachments_list";
import AttachmentUploaderButton from "src/components/attachments/AttachmentUploaderButton";

const PumiFiAttachmentsList = lazy(() =>
  import("src/pages/pumi.fi/components/PumiFiAttachments/PumiFiAttachmentsList")
);

export default function Kuvat({
  keikkaId = 0,
  ownerAsiakasId = 0,
  foreignKey = "",
  allowAdd = true,
  allowDelete = true,
  showPumiFiAttachments = false,
}) {
  const [key1, setKey1] = useState(0);
  const [key2, setKey2] = useState(100);
  const handleUpload = () => {
    setKey1((prev) => prev + 1);
    setKey2((prev) => prev + 1);
  };
  return (
    <Fade in timeout={300}>
      <div style={{ width: "100%", padding: "20px" }}>
        {foreignKey && showPumiFiAttachments && (
          <LazyLoader>
            <div style={{ width: "100%", paddingTop: "10px" }}>
              <PumiFiAttachmentsList foreignKey={foreignKey} key={key1} />
            </div>
            <MyDivider2 />
          </LazyLoader>
        )}
        <Attachments_list deAttachOnDelete key={key2} allowDelete={allowDelete} />
        {allowAdd && (
          <div className="center" style={{ justifyContent: "flex-end", paddingTop: "8px" }}>
            <AttachmentUploaderButton
              keikkaId={keikkaId}
              ownerAsiakasId={ownerAsiakasId}
              variant="outlined"
              onUpload={handleUpload}
            />
          </div>
        )}
      </div>
    </Fade>
  );
}

Kuvat.propTypes = {
  keikkaId: PropTypes.number,
  allowAdd: PropTypes.bool,
  allowDelete: PropTypes.bool,
  showPumiFiAttachments: PropTypes.bool,
  foreignKey: PropTypes.string,
  ownerAsiakasId: PropTypes.number.isRequired,
};
